import styled from 'styled-components'
import { pxToRem } from '../../utils'

const Content = styled.div`
  min-height: calc(100% - ${pxToRem(104)});
  max-height: 100%;
  flex: 1 calc(100% - ${pxToRem('217px')});
  -ms-flex: 1;
  box-sizing: border-box;
  overflow: auto;
  padding: ${pxToRem(117 + 30)} ${pxToRem(30)} ${pxToRem(30)};

  @media only screen and (max-width: 1000px) {
    max-width: 100%;
    overflow: auto;
    ${({ scapeSearch = false }) => scapeSearch ? `
      padding-top: ${pxToRem(117 + 30 + 50)};
    ` : ''}
  }

  @media only screen and (max-width: 700px) {
    padding: ${pxToRem(70 + 30)} ${pxToRem(30)} ${pxToRem(30)};
    ${({ scapeSearch = false }) => scapeSearch ? `
      padding-top: ${pxToRem(70 + 30 + 60)};
    ` : ''}
  }
`

export default Content



// WEBPACK FOOTER //
// ./src/components/Layout/Content.js